import { inject } from '@angular/core';
import { CanActivateFn, UrlTree } from '@angular/router';
import { map } from 'rxjs';
import { UrlTreeProvider } from '@core/routing/providers/url-tree.provider';
import { RouterPath } from '@core/routing/enums/router-path';
import { AuthService } from '@core/auth/services/auth.service';

export const OnlyNotLoggedGuard: CanActivateFn = (
  route,
  state,
  auth = inject(AuthService),
  urlTreeProvider = inject(UrlTreeProvider),
) => {
  const rootPageUrlTree = (): UrlTree =>
    urlTreeProvider.urlTree(RouterPath.ROOT);

  return auth
    .isLoggedIn()
    .pipe(map((isLogged) => !isLogged || rootPageUrlTree()));
};
